// extracted by mini-css-extract-plugin
export default {"pinIcon":"EmailTemplatePicker_pinIcon__1e60k","checkedPinIcon":"EmailTemplatePicker_checkedPinIcon__bC1gp"};